// edit-attribute-form.component.ts
export const NAME_INPUT = 'name-input';
export const VALUE_TYPE_SELECT = 'value-type-select';
export const INITIAL_VALUE_INPUT = 'initial-value-input';
export const ADD_TO_HIRE_ITEM_NOTES_CB = 'add-to-hire-item-notes-cb';
export const DISPLAY_ON_PUBLIC_PAGE_CB = 'display-on-item-public-page-cb';
export const PROMPT_ENABLED_SUFFIX = '-prompt-enabled-cb';
export const PROMPT_TYPE_SELECT_SUFFIX = '-prompt-type-select';
